module.exports = __webpack_public_path__ + "static/media/17991994_1834121616842493_2318086490994311500_n.a7e1ff7b.jpg";